module.exports = __webpack_public_path__ + "img/litespeed.eef5a6b4.png";